import { createSlice } from '@reduxjs/toolkit';
import { getVehicleReview } from '../thunks/commonInfoThunks';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const slice = createSlice({
    name: 'vehicleReview',
    initialState,
    reducers: {
        clearVehicleReview: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVehicleReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVehicleReview.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getVehicleReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearVehicleReview } = slice.actions;

export const selectVehicleReview = (state) =>
    state.commonData.vehicleReview.data;
export const selectVehicleReviewLoading = (state) =>
    state.commonData.vehicleReview.loading;

export const vehicleReview = slice.reducer;
